import { useEffect } from "react";
import s from "./Modal.module.scss";

type ModalProps = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  flush?: boolean;
};

export default function Modal({
  children,
  isOpen,
  onClose,
  flush = false,
}: ModalProps) {
  useEffect(() => {
    if (!isOpen) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={s.overlay} onClick={onClose}>
      <div
        className={`${s.modal} ${flush ? s.modalFlush : ""}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className={`${s.modalContent} ${flush ? s.modalContentFlush : ""}`}>
          {children}
        </div>
      </div>
    </div>
  );
}